import {GameActionCreators} from "../../../store/reducers/game/action-creators";
import {AppDispatch, store} from "../../../store";
import {AnimationActionCreators} from "../../../store/reducers/animation/action-creation";
import {IShowHpChange} from "../../../models/game/IShowHpChange";

export default class HP {
    static async set(side, value, dispatch: AppDispatch) {

        const state = store.getState();

        const method = 'set' + side + 'Hp';
        await dispatch(GameActionCreators[method](value));
        side = side.toLowerCase();

        if(value === 0){
            return;
        }

        let data: IShowHpChange = {
            side: side,
            value: null
        }
        if (side === 'player') {
            data.value = state.game.playerHp;
        } else {
            data.value = state.game.cpuHp;
        }
        if(data.value === 0){
            return;
        }

        data.value = value - data.value;
        if(data.value === 0){
            return;
        }

        let timeout = 1;

        if (state.game.cpuPlayedCard.card !== null) {
            timeout = 1000;
        }


        setTimeout(()=>{
            dispatch(AnimationActionCreators.setShowHpChange(data));

            setTimeout(()=>{
                dispatch(AnimationActionCreators.setShowHpChange( {
                    side: null,
                    value: null
                }))
            }, 700);

        }, timeout);




    }
}